import {useNavigate} from "react-router-dom";

export const useGotoCompetition = ({title}) => {
    const navigate = useNavigate();
    const goto = () => {
        navigate(`/competition/${title.competitionID}`);
    }

    return goto;
}
